/**
 * Build / version visibility.
 *
 * BUILD_RELEASE is a human-readable release label — bump it per meaningful
 * deploy so admins can see "which release" a device is running. The actual,
 * automatically-unique-per-build identifier is the CRA bundle hash, read at
 * runtime from /asset-manifest.json (which the build pipeline regenerates on
 * every deploy). Comparing the hash we loaded with on first paint against the
 * one the server currently advertises is how we detect a newer deploy — this
 * app intentionally runs WITHOUT a caching service worker (see public/index.html),
 * so manifest polling is the reliable signal.
 *
 * Exposes only build identifiers — never secrets or env vars.
 */
export const BUILD_RELEASE = "compliance-2026-06-18";

/** Fetch the currently-deployed main bundle hash from CRA's asset-manifest.
 *  Returns null in dev / when unavailable (so we never show a false prompt). */
export async function fetchDeployedBundle() {
  try {
    const res = await fetch(`/asset-manifest.json?_=${Date.now()}`, { cache: "no-store" });
    if (!res.ok) return null;
    const ct = res.headers.get("content-type") || "";
    if (!ct.includes("json")) return null; // dev server returns index.html
    const data = await res.json();
    const main = data && data.files && data.files["main.js"];
    if (!main || typeof main !== "string") return null;
    const m = main.match(/main\.([a-z0-9]+)\.js/i);
    return { mainPath: main, hash: m ? m[1] : main };
  } catch {
    return null;
  }
}
